module.exports = __webpack_public_path__ + "img/papillary-reaction-0.ed5f7812.jpg";